<template>
  <div class="park">
    <ParkInfos></ParkInfos>
    <div class="parkcont" v-if="routeName==='Overview' || routeName === 'Piles'">
      <div class="title">
        项目信息
      </div>
      <div class="Information row-center">
        <div class="img">
          <img :src="parkInfo.projectImg" alt="">
        </div>
        <div class="adress">
          <ul>
            <li style="line-height: 25rem;height:auto">
              <span class="name">项目地址：</span>
              <span class="cont u-line-2">{{ parkInfo.projectAddress }}</span>
            </li>
            <li>
              <span class="name">辖区面积：</span>
              <span class="cont">{{ parkInfo.projectArea }} ㎡</span>
            </li>
            <li>
              <span class="name">电压等级：</span>
              <span class="cont"
                    v-if="JSON.parse(parkInfo.projectDetailsInfo)['供电电压']">{{
                  JSON.parse(parkInfo.projectDetailsInfo)['供电电压'] ? JSON.parse(parkInfo.projectDetailsInfo)['供电电压'] + ' kV' : "--"
                }}  </span>
              <span class="cont grey" v-else>--</span>
            </li>
            <li>
              <span class="name">供电来源：</span>
              <span class="cont u-line-1" v-if="parkInfo.projectPowerOrigin">{{ parkInfo.projectPowerOrigin }}</span>
              <span class="cont u-line-1 grey" v-else>--</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="title">
        能耗信息
      </div>
      <div class="energy">
        <div class="plan row-center">
          <div class="item" style="width: 33%;">
            <div class="name">今日用电</div>
            <div
                :class="projectBoard.energyInfo && projectBoard.energyInfo.todayUseElectricity == '0.00'?'num grey':'num'">
              {{
                projectBoard.energyInfo && projectBoard.energyInfo.todayUseElectricity && projectBoard.energyInfo.todayUseElectricity !== '0.00' ? Number(projectBoard.energyInfo.todayUseElectricity).toFixed(2) + ' kWh' : '--'
              }}
            </div>
          </div>
          <div class="item" style="width: 33%;">
            <div class="name">较昨日</div>
            <div :class="difference == '0.00'?'num grey':'num'">{{ difference == '0.00' ? '--' : difference + ' kWh' }}
              <img v-show="difference !== '0.00'"
                   :src="difference <0?require('@/assets/img/jiang.png'):require('@/assets/img/shang.png')" alt="">
            </div>
          </div>
          <div class="item" style="width: 33%;">
            <div class="name">节约标准煤</div>
            <div
                :class="projectBoard.energyInfo && projectBoard.energyInfo.todayElectricityCoal && projectBoard.energyInfo.todayElectricityCoal == '0.00' ?'num grey':'num' ">
              {{
                projectBoard.energyInfo && projectBoard.energyInfo.todayElectricityCoal && projectBoard.energyInfo.todayElectricityCoal !== '0.00' ? Number(projectBoard.energyInfo.todayElectricityCoal).toFixed(2) + ' tce' : '--'
              }}
            </div>
          </div>
        </div>
        <div class="plan row-center" style="border-top:0">
          <div class="item" style="width: 33%;">
            <div class="name">今日用水</div>
            <div :class="projectBoard.energyInfo &&  projectBoard.energyInfo.todayUseWater == '0.00'?'num grey':'num'">
              {{
                projectBoard.energyInfo && projectBoard.energyInfo.todayUseWater && projectBoard.energyInfo.todayUseWater !== '0.00' ? Number(projectBoard.energyInfo.todayUseWater).toFixed(2) + ' m³' : '--'
              }}
            </div>
          </div>
          <div class="item" style="width: 33%;">
            <div class="name">今日用冷</div>
            <div
                :class="projectBoard.energyInfo  && projectBoard.energyInfo.todayUseCooling == '0.00'?'num grey':'num' ">
              {{
                projectBoard.energyInfo && projectBoard.energyInfo.todayUseCooling && projectBoard.energyInfo.todayUseCooling !== '0.00' ? Number(projectBoard.energyInfo.todayUseCooling).toFixed(2) + ' GJ' : '--'
              }}
            </div>
          </div>
          <div class="item" style="width: 33%;">
            <div class="name">今日用热</div>
            <div :class="projectBoard.energyInfo &&  projectBoard.energyInfo.todayUseHeat == '0.00'?'num grey':'num' ">
              {{
                projectBoard.energyInfo && projectBoard.energyInfo.todayUseHeat && projectBoard.energyInfo.todayUseHeat !== '0.00' ? Number(projectBoard.energyInfo.todayUseHeat).toFixed(2) + ' GJ' : '--'
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="title">
        光伏信息
      </div>
      <div class="energy">
        <div class="plan row-center">
          <div class="item">
            <div class="name">今日发电</div>
            <div
                :class="projectBoard.energyInfo && projectBoard.electricityInfo.todayGenerate == '0.00'?'num grey':'num' ">
              {{
                projectBoard.energyInfo && projectBoard.electricityInfo.todayGenerate !== '0.00' ? Number(projectBoard.electricityInfo.todayGenerate).toFixed(2) + ' kWh' : '--'
              }}
            </div>
          </div>
          <div class="item">
            <div class="name">今日收益</div>
            <div
                :class="projectBoard.energyInfo && projectBoard.electricityInfo.todayIncome == '0.00'?'num grey':'num'">
              {{
                projectBoard.energyInfo && projectBoard.electricityInfo.todayIncome !== '0.00' ? Number(projectBoard.electricityInfo.todayIncome).toFixed(2) + ' ￥' : '--'
              }}
            </div>
          </div>
          <div class="item">
            <div class="name">装机容量</div>
            <div class="num" :style="projectCapacity? 'color:#333;':'color:#999;'">
              {{ projectCapacity ? projectCapacity + ' kVA' : '--' }}
            </div>
          </div>
          <div class="item">
            <div class="name">光伏电站容量</div>
            <div class="num" :style="projectPvCapacity? 'color:#333;':'color:#999;'">
              {{ projectPvCapacity ? projectPvCapacity + ' kWp' : '--' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    配电概况-->
    <div class="transformer" v-else-if="routeName=='PowerDistribution'">
      <div class="" v-if="$store.getters.areaId!=78&&$store.getters.areaId!=79">
        <div class="evaluation">
          配电概况
        </div>
        <div class="land">
          <div class="item">
            <div class="tt">当前最高负载率</div>
            <div :class="topTransforLoad.val == '--'? 'num grey' :'num ' + loadColor">
              {{ topTransforLoad.val == '--' ? '--' : topTransforLoad.val + ' %' }}
            </div>
            <div class="name"><b>{{ topTransforLoad.name }}</b></div>
          </div>
          <div class="item">
            <div class="tt">变压器总台数：</div>
            <div :class="topTransforLoad.length == '--'?'num grey':'num green' ">
              {{ topTransforLoad.length == '--' ? '--' : topTransforLoad.length + ' 台' }}
            </div>
          </div>
          <!-- <div class="item" v-if="projectId!=18&&projectId!=4"> -->
          <div class="item">
            <div class="tt">框架断路器状态</div>
            <div :class="breakerInfo.length == 0?'num grey':'num green'">
              合闸：{{ breakerInfo.length > 0 ? breakInline + ' 台' : '--' }}
            </div>
            <div :class="breakerInfo.length == 0?'name grey': 'name'">
              共：{{ breakerInfo.length > 0 ? breakerInfo.length + ' 台' : '--' }}
            </div>
          </div>
          <!-- <div class="item" v-else-if="projectId==4">
              <div class="tt">框架断路器状态</div>
              <div class="num green">合闸：2 台</div>
              <div class="name">共：3 台 </div>
          </div>
          <div class="item" v-else>
              <div class="tt">框架断路器状态</div>
              <div class="num green">合闸：3 台</div>
              <div class="name">共：3 台 </div>
          </div> -->
        </div>
        <div class="land">
          <div class="item">
            装机总容量：<span
              :class="topTransforLoad.capSun == '--'? 'grey':''">{{
              topTransforLoad.capSun == '--' ? '--' : topTransforLoad.capSun + ' kVA'
            }} </span>
          </div>
          <div class="item">
            电压等级：<span
              :class="topTransforLoad.level !== '--' ? '':'grey'">{{
              topTransforLoad.level == '--' ? '--' : topTransforLoad.level
            }}</span>
          </div>
        </div>
        <div class="evaluation">
          电力信息
        </div>
        <div class="chart row-center">
          <div class="tabHvl" >
            <span :class="loopidx == index?'se':''" v-for="(item, index) in currentLoops" @click="tabCabLoop(index)"
                  :key="item.loopId">{{ $store.getters.projectId==13?item.loopName:item.loopName.split('-')[0] }}</span>
          </div>
          <!-- <div class="item">
              <div class="name">功率因数</div>
              <div class="box">
                  <percentage type="dashboard" :hasValue="capacitor.pf + ''" :percentage="capacitor.pf !== '--'?capacitor.pf:0" color="#5AD8A6" :format="format" ></percentage>
              </div>
              <div class="statue">优</div>
          </div>
          <div class="item">
              <div class="name">电流谐波</div>
              <div class="box">
                  <percentage type="dashboard" :hasValue="capacitor.i + ''" :percentage="capacitor.i !== '--'?capacitor.i:0" color="#269A99"></percentage>
              </div>
              <div class="statue">优</div>
          </div>
          <div class="item">
              <div class="name">电压谐波</div>
              <div class="box">
                  <percentage type="dashboard" :hasValue="capacitor.u + ''" :percentage="capacitor.u !== '--'?capacitor.u:0" color="#269A99"></percentage>
              </div>
              <div class="statue">优</div>
          </div> -->
        </div>
        <div class="addbox">
          <div class="additem" v-for="item in cabLine" :key="item.id">
            <p>{{ item.name }}</p>
            <p :class="item.val == '--'?'grey':''">{{ item.val }} <span v-show="item.val != '--'">{{ item.unit }}</span>
            </p>
          </div>
        </div>
      </div>
      <EYMPower v-else></EYMPower>
    </div>
    <!--    发电概况-->
    <div class="Photovoltaic" v-else-if="routeName=='Photovoltaic'">

      <div class="title">
        发电概况
      </div>
      <div class="box">
        <div class="land">
          <div class="item">
            <div class="name">本日发电</div>
            <div class="num">{{ Number(generateYearNumInfo.dayGenerate).toFixed(2) }}<span> kWh</span></div>
          </div>
          <div class="item">
            <div class="name">本月发电</div>
            <div class="num">{{ Number(generateYearNumInfo.monthGenerate).toFixed(2) }}<span> kWh</span></div>
          </div>
          <div class="item">
            <div class="name">本年发电</div>
            <div class="num">{{ generateYearNumInfo.yearGenerate }}<span> kWh</span></div>
          </div>
        </div>
        <div class="land">
          <div class="item">
            <div class="name">本日收益</div>
            <div class="num">{{ Number(generateYearNumInfo.dayGenerateCost).toFixed(2) }}<span> ￥</span></div>
          </div>
          <div class="item">
            <div class="name">本月收益</div>
            <div class="num">{{ Number(generateYearNumInfo.monthGenerateCost).toFixed(2) }}<span> ￥</span></div>
          </div>
          <div class="item">
            <div class="name">本年收益</div>
            <div class="num">{{ Number(generateYearNumInfo.yearGenerateCost).toFixed(2) }}<span> ￥</span></div>
          </div>
        </div>
        <div class="land">
          <div class="item">
            <div class="name">本日碳减排</div>
            <div class="num">{{ Number(generateYearNumInfo.dayGenerateCarbon).toFixed(2) }}<span> kg</span></div>
          </div>
          <div class="item">
            <div class="name">本月碳减排</div>
            <div class="num">{{ Number(generateYearNumInfo.monthGenerateCarbon).toFixed(2) }}<span> kg</span></div>
          </div>
          <div class="item">
            <div class="name">本年碳减排</div>
            <div class="num">{{ Number(generateYearNumInfo.yearGenerateCarbon).toFixed(2) }}<span> kg</span></div>
          </div>
        </div>
      </div>

      <div class="title">
        电站概况
      </div>
      <div class="land landl">
        <div class="item">
          <div class="name">光伏电站容量</div>
          <div class="num" style="color:#333333">{{ total }}<span> kWp</span></div>
        </div>
        <div class="item">
          <div class="name">逆变器数量</div>
          <div class="num" style="color:#333333">{{ InverterList.length }} 台</div>
        </div>
        <div class="item">
          <div class="name">组串数量</div>
          <div class="num" style="color:#333333">{{ zuTotal }} 个</div>
        </div>
        <div class="item">
          <div class="name">光伏板数量</div>
          <div class="num" style="color:#333333">274 块</div>
        </div>
      </div>
    </div>
    <div class="Photovoltaic" v-else-if="routeName=='EnergyConsumption'">
      <EnergyOver/>
    </div>
    <div class="Photovoltaic" v-else-if="routeName=='PaymentMeter'">
      <PayOverview/>
    </div>
    <div class="Photovoltaic" v-else-if="routeName=='Chargingpile'">
      <ChargInfo/>
    </div>
    <div class="Photovoltaic" v-else-if="routeName=='PowerStation'">
      <StationInfo/>
    </div>
  </div>
</template>
<script>
import percentage from './progress';
import ParkInfos from './ParkInfos';

import EnergyOver from '../../views/EnergyConsumption/components/EnergyOver.vue'
import PayOverview from '../../views/PaymentMeter/components/PayOverview.vue'
import ChargInfo from '../../views/Chargingpile/components/ChargInfo'
import StationInfo from '../../views/PowerStation/components/StationInfo'
import EYMPower from './EYMPower'

import {
  getOverviewDashboard,
  getProjectcapacity,
  getPvcapacity,
  distributeDashboard,
  InverterArea,
  generateYear,
  getAreaCabLine,
  getAreaCapacitor,
  generateOverview,
  GetWireByDeviceID,
  getInverterSeries,
} from '../../api/power.js'
import {floatFormat} from "../../util/MathUtil";
import {subscribe} from '../../mqtt/index'

export default {
  data() {
    return {
      percentage: 80,
      colors: [
        {color: '#f56c6c', percentage: 20},
        {color: '#e6a23c', percentage: 40},
        {color: '#5cb87a', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#6f7ad3', percentage: 100}
      ],
      projectBoard: {},
      projectPvCapacity: null,
      projectCapacity: null,
      breakerInfo: [],
      InverterList: [], //逆变器
      generateYearNumInfo: {}, //光伏概况
      loopidx: 0, // 电能质量选择回路
      currentLoops: [], // 配电模块电能质量进线数组
      total: 0,
      zuTotal: 0
    }
  },
  components: {
    percentage, ParkInfos, EnergyOver, PayOverview, ChargInfo,StationInfo,EYMPower
  },
  computed: {
    
		areaId(){
			return this.$store.getters.areaId==80?72:this.$store.getters.areaId
		},
    loadColor() {
      let color = this.topTransforLoad.val > 110 ? 'red' : this.topTransforLoad.val >= 80 && this.topTransforLoad.val <= 100 ? 'yellow' : 'normal'
      return color
    },
    // capacitor(){
    // if(!this.currentLoops[this.loopidx] ) return {pf:'--', i:'--', u:'--'}

    // let pf = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl+'/PF') == '--'?'--':this.mqttval(this.currentLoops[this.loopidx].subLoopUrl+'/PF') * 100
    // if(pf >= 100){
    //     pf = 100
    // }else if(pf<=0){
    //     pf = 0
    // }

    // let i = this.mqttval(this.currentLoops[this.loopidx].capacitor.subLoopUrl+'/THD_I') == '--'?'--':this.mqttval(this.currentLoops[this.loopidx].capacitor.subLoopUrl+'/THD_I') / 1
    // let u = this.mqttval(this.currentLoops[this.loopidx].capacitor.subLoopUrl+'/THD_U') == '--'?'--':this.mqttval(this.currentLoops[this.loopidx].capacitor.subLoopUrl+'/THD_U') / 1
    // return {
    //     pf, i, u
    // }
    // },
    cabLine() {
      if (this.currentLoops.length > 0) {
        let A = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl + '/Ia')
        let B = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl + '/Ib')
        let C = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl + '/Ic')
        let PF = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl + '/PF')
        let P = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl + '/P')
        let PR = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl + '/PR')
        let PA = this.mqttval(this.currentLoops[this.loopidx].subLoopUrl + '/PA')

        // console.log(A, B, C, PF, P, PR, PA);
        return [
          {
            id: 1,
            name: 'A相电流',
            val: A,
            unit: 'A'
          },
          {
            id: 2,
            name: 'B相电流',
            val: B,
            unit: 'A'
          },
          {
            id: 3,
            name: 'C相电流',
            val: C,
            unit: 'A'
          },
          {
            id: 4,
            name: '功率因数',
            val: PF,
            unit: ''
          },
          {
            id: 5,
            name: '有功功率',
            val: P == '--' ? '--' : (P / 1000).toFixed(2),
            unit: 'kW'
          },
          {
            id: 6,
            name: '无功功率',
            val: PR == '--' ? '--' : (PR / 1000).toFixed(2),
            unit: 'kVar'
          },
          {
            id: 7,
            name: '视在功率',
            val: PA == '--' ? '--' : (PA / 1000).toFixed(2),
            unit: 'kVA'
          },
        ]
      } else {
        return [
          {
            id: 1,
            name: 'A相电流',
            val: '--',
            unit: 'A'
          },
          {
            id: 2,
            name: 'B相电流',
            val: '--',
            unit: 'A'
          },
          {
            id: 3,
            name: 'C相电流',
            val: '--',
            unit: 'A'
          },
          {
            id: 4,
            name: '功率因数',
            val: '--',
            unit: ''
          },
          {
            id: 5,
            name: '有功功率',
            val: '--',
            unit: 'kWh'
          },
          {
            id: 6,
            name: '无功功率',
            val: '--',
            unit: 'kVar'
          },
          {
            id: 7,
            name: '视在功率',
            val: '--',
            unit: 'kVA'
          },
        ]
      }
    },
    routeName() {
      return this.$route.params.name;
    },
    parkInfo() {
      return this.$store.state.project.projectInfo
    },
    WeatherInfo() {
      return this.$store.state.project.WeatherInfo
    },
    difference() {
      if (Object.keys(this.projectBoard).length > 0) {
        let a = this.projectBoard.energyInfo.todayUseElectricity ? Number(this.projectBoard.energyInfo.todayUseElectricity).toFixed(2) : 0
        let b = this.projectBoard.energyInfo.yesterdayUseElectricity ? Number(this.projectBoard.energyInfo.yesterdayUseElectricity).toFixed(2) : 0
        // console.log(a, b);
        return (a - b).toFixed(2)
      } else {
        return '0.00'
      }
    },
    projectId() {
      return this.$store.getters.projectId
    },
    mqttval() {
      return this.getMqttVal(this.$store.getters.mqttVal);
    },
    topTransforLoad() {
      let arr = []
      let capSun = 0
      // if(this.$store.getters.projectId==1){
      // 	let current = this.$store.state.project.transformerList.filter(item =>item.area_id == this.$store.getters.areaId)
      // 	current.forEach(item =>{
      // 		let la = this.mqttval(item.subLoopUrl +'/Ia')
      // 		let Ib = this.mqttval(item.subLoopUrl +'/Ib')
      // 		let Ic = this.mqttval(item.subLoopUrl +'/Ic')

      // 		let a = la == '--'?0:Number(la)
      //         let b = Ib == '--'?0:Number(Ib)
      //         let c = Ic == '--'?0:Number(Ic)
      // 		let zong = la == '--' &&  Ib == '--' && Ic == '--'?'--': a + b + c;
      // 		let v = zong == '--'?'--': zong/3/(parseFloat(JSON.parse(item.device_details)['电气']['容量'])*1000/400/Math.sqrt(3))*100;


      //         arr.push({
      //             transformer:item.deviceName,
      //             val:v=='--'?'--':Number(v).toFixed(2),
      //             level:JSON.parse(item.device_details)['电气']['额定电压']
      //         })
      //         capSun += parseFloat(JSON.parse(item.device_details)['电气']['容量'])
      // 	})
      // }else{
      let current = this.$store.state.project.transformerList.filter(item => item.area_id == this.areaId)
      if(this.$store.getters.areaId==75){
        current.forEach(item => {
          let val = this.mqttval(item.subLoopUrl + '/PA')
          arr.push({
            transformer: item.deviceName,
            val: val !== '--' ? Number(Math.abs(val) / parseFloat(JSON.parse(item.device_details)['电气']['容量']) / 10).toFixed(2) : 0,
            level: JSON.parse(item.device_details)['电气']['额定电压']
          })
          capSun += parseFloat(JSON.parse(item.device_details)['电气']['容量'])
        })
      }else{
        current.forEach(item => {
          let val = this.mqttval(item.subLoopUrl + '/P')
          arr.push({
            transformer: item.deviceName,
            val: val !== '--' ? Number(Math.abs(val) / parseFloat(JSON.parse(item.device_details)['电气']['容量']) / 10).toFixed(2) : 0,
            level: JSON.parse(item.device_details)['电气']['额定电压']
          })
          capSun += parseFloat(JSON.parse(item.device_details)['电气']['容量'])
        })
      }
      
      // }


      if (arr.length > 0) {
        let max = arr.sort((a, b) => b.val - a.val)[0]
        // console.log(max);
        return {
          val: max.val == 0 ? '--' : max.val,
          name: max.transformer,
          length: arr.length,
          capSun,
          level: max.level ? max.level : '--'
        }
      } else {
        return {
          val: '--',
          name: '--',
          length: '--',
          capSun: '--',
          level: '--'
        }
      }
    },
    breakInline() {
      let sum = 0
      this.breakerInfo.forEach(item => {
        if (item.loop_url) {
          let subloopurl = item.loop_url.split('/')
          subloopurl.shift(0, 1)
          subloopurl = subloopurl.join('/')
          let val = this.mqttval(subloopurl + '/SwitchOn')
          if (val == 1) {
            sum += Number(val)
          }
        }

      })
      return sum
    },
    transformerLoad() {
      let currentTransformer = {}
      if (Object.keys(this.currentLoops).length == 0) return '--'
      this.$store.getters.getAreaTransformer.forEach(item => {
        let trans = item.transformerList.find(item1 => item1.pid == this.currentLoops[this.loopidx].loopId)
        if (trans) {
          currentTransformer = trans
        }
      })
      if (Object.keys(currentTransformer).length > 0) {
        // let load = this.mqttval(currentTransformer.subLoopUrl+'/P') / 10 / parseInt(JSON.parse(currentTransformer.device_details)['电气']['容量'])
        let load = this.mqttval(currentTransformer.subLoopUrl + '/P') == '--' ? '--' : (this.mqttval(currentTransformer.subLoopUrl + '/P') / 1000).toFixed(2)
        return load
      } else {
        return '--'
      }
    }
  },
  mounted() {
    this.getOverview()
    this.getBoard()
    this.getCapacity()
    this.getPvCapacity()
    this.getInverterArea()
    this.getGenerateYear()
    this.getAreaCabline()


  },
  watch: {
    '$store.getters.areaId'() {
      this.getOverview()
      this.getAreaCabline()
      this.getInverterArea()
    },
    routeName() {
      this.getInverterArea()
      this.getGenerateYear()
    },
    '$store.getters.projectId'() {
      this.projectCapacity = null
      this.getOverview()
      this.getBoard()
      this.getCapacity()
      this.getPvCapacity()
      this.getInverterArea()
      this.getGenerateYear()
      this.getAreaCabline()
    },
  },
  methods: {
    //年发电量
    async getGenerateYear() {
      let response = await generateOverview();
      this.generateYearNumInfo = response.data.data;
    },
    //逆变器
    async getInverterArea() {
      let response = await InverterArea(this.$store.getters.areaId);
      this.InverterList = response.data.data.loops || [];
      // console.log(response);
      this.InverterList.forEach(item => {
        subscribe([item.subLoopUrl]);
      })

      let total = 0
      let zuTotal = 0
      try {
        response.data.data.loops.forEach(async (item) => {
          let res = await GetWireByDeviceID(item.deviceId)
          let details = res.data.data.device.device_details
          let cap = parseFloat(JSON.parse(details)['电气']['容量'])
          total += cap
          
          let res1 = await getInverterSeries({
            inverterId: item.loopId
          })

          console.log(res1);
          zuTotal += res1.data.data.length
          this.total = total
          this.zuTotal = zuTotal
        })


      } catch (err) {
        // console.log(err);
      }

    },
    getDistanceSpecifiedTime(dateTime) {
      var EndTime = new Date(dateTime);
      var NowTime = new Date();
      var t = NowTime.getTime() - EndTime.getTime();
      var d = Math.floor(t / 1000 / 60 / 60 / 24);
      return d;
    },
    format(percentage) {
      return Number(Number(percentage) / 100).toFixed(2);
    },
    async getBoard() {
      let res = await getOverviewDashboard()
      if (res.data.code == 200) {
        this.projectBoard = res.data.data
        // console.log(res.data.data);
      } else {
        // console.log(res.data.errMsg);
      }
    },
    async getCapacity() {
      let res = await getProjectcapacity()
      if (res.data.code == 200) {
        this.projectCapacity = res.data.data.res
      } else {
        // console.log(res.data.errMsg);
      }
    },
    async getPvCapacity() {
      let res = await getPvcapacity()
      if (res.data.code == 200) {
        let sum = 0
        res.data.data.devices.forEach(item => {
          let capacity = parseFloat(JSON.parse(item.deviceDetails)['电气']['容量'])
          sum += capacity
        })
        this.projectPvCapacity = sum
      } else {
        // console.log(res.data.errMsg);
      }
    },
    async getOverview() {
      let res = await distributeDashboard({
        projectId: this.$store.getters.projectId,
        areaId: this.areaId
      })

      if (res.data.code == 200) {
        // console.log(res);
        this.breakerInfo = res.data.data.breakerInfo


        this.breakerInfo.forEach(item => {
          // subscribe([item.subLoopUrl])
          if (item.loop_url) {
            let subloopurl = item.loop_url.split('/')
            subloopurl.shift(0, 1)
            subloopurl = subloopurl.join('/')
            subscribe([subloopurl])
          }

        })
      } else {
        // console.log(res.data.errMsg);
      }
    },
    getMqttVal(f) {
      return (k, m) => {
        if (k) {
          let mqttVal = f(k);
          if (m) {
            mqttVal *= m;
          }
          mqttVal = floatFormat(mqttVal, 2);
          if (typeof mqttVal === "object") {
            return mqttVal;
          }
          return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
        } else {
          return "--";
        }
      };
    },
    // 获取区域进线
    async getAreaCabline() {
      let res = await getAreaCabLine({
        areaId: this.areaId
      })
      // console.log(res);
      if (res.data.code == 200) {
        // this.currentLoops = res.data.data.loops
        this.getAreaCap(res.data.data.loops)
      } else {
        // console.log('err:' +res.data.errmsg);
      }
    },
    tabCabLoop(idx) {
      this.loopidx = idx
    },
    // 获取区域电容补偿柜
    async getAreaCap(loops) {
      let _this = this

      loops.forEach(item => {
        subscribe([item.subLoopUrl])
      })
      _this.currentLoops = loops

      // let res = await getAreaCapacitor({
      //     areaId:this.$store.getters.areaId
      // })
      // if(res.data.code == 200){
      //     loops.forEach(item =>{
      //         subscribe([item.subLoopUrl])
      //         let cap = res.data.data.res.find(item1 =>item1.pid == item.loopId)
      //         if(cap){
      //             item.capacitor = cap
      //             subscribe([cap.subLoopUrl])
      //         }
      //     })
      //     _this.currentLoops = loops
      // }else{
      //     console.log('err:' +res.data.errmsg);
      // }
    }
  }
}
</script>

<style lang="less" scoped>

.park {
  height: 100%;

  .title {
    font-size: 16rem;
    border-left: 5rem solid #0D94FF;
    height: 18px;
    line-height: 18px;
    padding-left: 6px;
    margin: 10rem 0 5rem 0
  }

  .parkcont {
    padding: 0 12rem;

    .Information {
      .h(173);
      background: rgba(0, 43, 102, 0.04);
      justify-content: space-between;
      align-items: flex-start;
      padding: 10rem 0;
      border-top: 1px solid rgba(0, 0, 0, 0.15);

      .img {
        .w(240);
        height: 100%;

        img {
          height: 100%;
          width: 100%;
        }
      }

      .adress {
        .w(320);

        li {
          font-size: 16rem;
          line-height: 38rem;
          height: 36rem;
          border-bottom: 1px solid rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: flex-start;

          span {
            display: inline-block;
          }

          .name {
            // .w(80);
          }

          .cont {
            // .w(230);
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            flex: 1;
            padding-right: 10px;
          }
        }
      }

      li:last-child {
        border: 0
      }
    }

    .energy {
      .plan {
        justify-content: space-between;
        background: rgba(0, 43, 102, 0.04);
        border-top: 1px solid rgba(0, 0, 0, 0.15);
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
        .h(76);
        padding: 0 20rem;

        img {
          height: 23rem;
        }

        .item {
          display: inline-block;
        }

        .name {
          font-size: 16rem;
          margin-bottom: 5rem;
        }

        .num {
          font-size: 18px;
          font-weight: bold;
          color: #0D94FF;
        }
      }
    }
  }

  .transformer {
    background: rgba(19, 28, 36, 0.024);
    padding: 0 12rem;
    font-size: 16rem;
    .h(525);

    .evaluation {
      height: 3.2vh;
      padding-top: 7rem;
      padding-left: 13rem;
      line-height: 28rem;
      box-sizing: border-box;
      font-size: 16rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      position: relative;

      &::before {
        content: '';
        width: 5rem;
        height: 18rem;
        background: #0D94FF;
        position: absolute;
        left: 0;
        top: 12.5rem;
      }
    }

    .chart {
      justify-content: space-between;
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      padding-top: 3.8vh;
      position: relative;

      .tabHvl {
        height: 3.8vh;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        & > span {
          display: inline-block;
          height: 3.8vh;
          // width: 2.5vw;
          text-align: center;
          line-height: 3.8vh;
          font-size: 16rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-left: 0.5vw;
          cursor: pointer;
          border-top: 2px solid transparent;
        }

        .se {
          border-top: 2px solid #0D94FF;
          color: #0D94FF;
        }
      }

      .item {
        width: 30%;
        .h(135);
        background: rgba(0, 43, 102, 0.02);
        border-radius: 12rem;
        text-align: center;
        padding: 20rem;

        .name {
          margin-bottom: 10rem;
        }

        .box {
          width: 100%;
          .h(120)
        }

        .statue {
          font-size: 24rem;
          font-weight: 500;
          color: #5AD8A6;
          margin-top: -40rem;
        }
      }
    }

    .land {
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      display: flex;
      // justify-content: space-between;

      padding: 15rem 20rem;
      min-height: 52rem;
      align-items: flex-start;

      .item {
        font-size: 16rem;
        width: 33%;

        .num {
          font-size: 30rem;
          font-weight: bold;
          margin-top: 5rem;
        }

        .red {
          color: #FD4238;
        }

        .normal {
          color: #68D86A;
        }

        .yellow {
          color: #F5AA00;
        }

        .green {
          color: #269A99;
        }

        .name {
          color: #666666;
        }

      }
    }

    .land:nth-child(3) {
      border-top: none;
    }

    .addbox {
      width: 100%;
      // height:14vh;
      display: flex;
      justify-content: flex-start;
      // align-items: center;
      flex-wrap: wrap;
      align-content: space-evenly;
      // background: #269A99;
      padding-top: 1vh;

      .additem {
        width: 23%;
        height: 9vh;
        margin-right: 2%;
        margin-bottom: 1vh;
        margin-bottom: 1vh;
        background: rgba(0, 43, 102, 0.02);
        border-radius: 12rem;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;

        & > p:nth-child(1) {
          font-size: 16rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }

        & > p:nth-child(2) {
          font-size: 22rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #0D94FF;

          & > span {
            font-size: 18rem;
          }
        }
      }
    }
  }

  .Photovoltaic {
    padding: 0 12rem;
    font-size: 16rem;

    .box {
      background: rgba(0, 43, 102, 0.04);
    }

    .land {
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 40rem;
      .h(86);

      .item {
        font-size: 16rem;
        width: 29%;

        .num {
          // margin-top: 10rem;
          font-size: 24rem;
          font-weight: bold;
          color: #0D94FF;

          span {
            font-size: 18rem;
          }
        }
      }
    }

    .landl {
      justify-content: left;
      background: rgba(0, 43, 102, 0.04);

      .item {
        width: 23.8%;

        .num {
          // color: #333333;
          font-size: 18rem;
        }
      }
    }
  }
}
</style>